<template>
  <div class="ffk-whats-new-sidebar-content">
    <iframe
      title="Release notes frame"
      ref="releaseNotesIframe"
      id="releaseNotesIframe"
      class="releaseNotesIframe"
      width="100%"
      :height="iframeHeight"
      :src="documentationPath"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'WhatsNewSidebarContent',
  props: {
    initialPath: String,
  },
  data() {
    return {
      iframeHeight: '0px', // initial height
    }
  },
  computed: {
    calculateHeight() {
      return window.innerHeight - 200
    },
    documentationPath() {
      return process.env.BASE_URL + this.initialPath
    },
  },
  mounted() {
    // set initial iframe height
    this.iframeHeight = `${this.calculateHeight}px`
    // setup event listener
    window.addEventListener('resize', this.handleIframeResize)
  },
  beforeDestroy() {
    // destroy event listener
    window.removeEventListener('resize', this.handleIframeResize)
  },
  methods: {
    handleIframeResize() {
      return window.innerHeight - 200
    },
  },
}
</script>

<style lang="scss" scoped>
.ffk-whats-new-sidebar-content {
  #releaseNotesIframe {
    width: 0;
    min-width: 100% !important;
    border: 0;
  }
}
</style>
